import { request } from './http';

const createAdminReservation = (reservation) => request('createAdminReservation', {
  body: reservation,
  authRequired: true
});

const confirmReservation = (reservationId) => request('confirmReservation', {
  body: { reservationId },
  authRequired: true
});

const denyReservation = (reservationId) => request('denyReservation', {
  body: { reservationId },
  authRequired: true
});

const cancelReservation = (reservationId, reason) => request('adminCancelReservation', {
  body: { reservationId, reason },
  authRequired: true
});

const updateReservation = (reservation) => request('updateReservation', {
  body: reservation,
  authRequired: true
});

const scanReservationQr = (reservationId) => request('scanReservationQr', {
  body: { reservationId },
  authRequired: true
});

const assignReservationTable = (reservationId, tableId) => request('assignReservationTable', {
  body: { reservationId, tableId },
  authRequired: true
});

const releaseReservationTable = (reservationId) => request('releaseReservationTable', {
  body: { reservationId },
  authRequired: true
});

const assignReservationGroup = (reservationId, groupId) => request('assignReservationGroup', {
  body: { reservationId, groupId },
  authRequired: true
});

const releaseReservationGroup = (reservationId) => request('releaseReservationGroup', {
  body: { reservationId },
  authRequired: true
});

const assignReservationWaiter = (reservationId, waiterId) => request('assignReservationWaiter', {
  body: { reservationId, waiterId },
  authRequired: true
});

const retryPaymentFailedNotification = (reservationId) => request('retryPaymentFailedNotification', {
  body: { reservationId },
  authRequired: true
});

const retryPaymentIncidentNotification = (reservationId) => retryPaymentFailedNotification(reservationId);

const manualReconcilePayments = () => request('manualReconcilePayments', {
  body: {},
  authRequired: true
});

const backfillHistoricalVoidIncidents = (options = {}) => request('backfillHistoricalVoidIncidents', {
  body: options,
  authRequired: true
});

const getCloverAuditLog = (limit = 100) => request('getCloverAuditLog', {
  body: { limit },
  authRequired: true
});

export {
  createAdminReservation,
  confirmReservation,
  denyReservation,
  cancelReservation,
  updateReservation,
  scanReservationQr,
  assignReservationTable,
  releaseReservationTable,
  assignReservationGroup,
  releaseReservationGroup,
  assignReservationWaiter,
  retryPaymentFailedNotification,
  retryPaymentIncidentNotification,
  manualReconcilePayments,
  backfillHistoricalVoidIncidents,
  getCloverAuditLog
};
